import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDrag } from '@angular/cdk/drag-drop';

@Component({
    selector: 'wire-popup-host',
    imports: [CommonModule, CdkDrag],
    templateUrl: './popup-host.component.html',
})
export class PopupHostComponent {
  @ViewChild('vc', { read: ViewContainerRef, static: true })
  vc!: ViewContainerRef;

  @Input() draggable = false;
  @Input() dragRootSelector = '.cdk-overlay-pane';
}
